import styled, { css } from 'styled-components';
import { QuestionListItem } from 'src/modules/profileSurvey/components/sharedStyles';
import { text } from 'styles-js/mixins/typography';
type Props = {
  isChecked: boolean;
  title: string;
  type: 'radio' | 'checkbox';
  onChange: (checked: boolean) => void;
};
export default function PollAnswer({
  isChecked,
  type,
  title,
  onChange
}: Props): JSX.Element {
  return <Answer $isChecked={isChecked} data-sentry-element="Answer" data-sentry-component="PollAnswer" data-sentry-source-file="pollAnswer.tsx">
      <TickBox checked={isChecked} name="poll" type={type} onChange={e => onChange(e.target.checked)} data-sentry-element="TickBox" data-sentry-source-file="pollAnswer.tsx" />
      <Title data-sentry-element="Title" data-sentry-source-file="pollAnswer.tsx">{title}</Title>
    </Answer>;
}
const Answer = styled(QuestionListItem)<{
  $isChecked: boolean;
}>`
  ${text};
  min-height: 60px;
  height: auto;
  padding: 10px;
  ${({
  $isChecked: checked
}) => checked && css`
    background-color: ${({
  theme
}) => theme.colorBlueBackground};
  `};
  @media (${({
  theme
}) => theme.underScreenXxsmall}) {
    height: auto;
  }
`;
const TickBox = styled.input`
  cursor: pointer;
`;
const Title = styled.span`
  word-wrap: break-word;
`;